// extracted by mini-css-extract-plugin
module.exports = {"row":"special_row__Vwk3A","amount":"special_amount__M676T","icon":"special_icon__VFp2k","symbol":"special_symbol__mQZhw"};